export default __webpack_public_path__ + "static/media/corporate-solutions.aa221a5f.svg";